export const NODE_RESET_STATE = 'NODE_RESET_STATE';
export const NODE_CURRENT_ITEM = 'NODE_CURRENT_ITEM';

export const NODE_REQUEST_LOADING = 'NODE_REQUEST_LOADING';
export const NODE_REQUEST_SUCCESS = 'NODE_REQUEST_SUCCESS';
export const NODE_REQUEST_FAILED = 'NODE_REQUEST_FAILED';

export const NODE_CURRENT_ACTION = 'NODE_CURRENT_ACTION';
export const NODE_RESET_ACTION = 'NODE_RESET_ACTION';